import { Injectable } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { Http, Headers } from '@angular/http';
import { AuthService } from './auth/auth.service';
import { LoginViewModel } from '../models/login-view-model';
import { userProfile } from '../models/userProfile';
import { CreditCard } from '../models/CreditCard';
import { User } from '../models/User';
import { BankAcc } from '../models/BankAcc';
// import 'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AdminService {

  myHeader: Headers;
  constructor(private http: Http,
    private authHttp: AuthHttp,
    public auth: AuthService) {
    this.myHeader = new Headers();
    this.myHeader.append('Content-Type', 'application/json');
    // To fix IE 11 cache API issue.
    this.myHeader.append('Cache-control', 'no-cache');
    this.myHeader.append('Cache-control', 'no-store');
    this.myHeader.append('Expires', '0');
    this.myHeader.append('Pragma', 'no-cache');
    console.log('Admin Service Initialized...');

  }

  ChangePassword(password: string, oldPassword?: string, bearerToken?: string) {


    return this.authHttp.post(`/api/AdminUser/ChangePassword`, {password, oldPassword, bearerToken},
     { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Change password request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }
  CheckPassword(password: string) {
    return this.authHttp.post(`/api/AdminUser/CheckPassword`, new Object(password), { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Check password request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  getUsers() {
    return this.authHttp.get(`/api/AdminUser/GetUsers`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Get Users request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  getUserInfo() {
    return this.authHttp.get(`/api/AdminUser/GetUserInfo`, { headers: this.myHeader }).map(res => {
      // tslint:disable-next-line:triple-equals
      if (res.status < 200 || res.status > 300) {

        throw new Error('GetuserInfo request has failed ' + res.status);
      } else { return res.json(); }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  ChangeProfile(poUserProfile: userProfile) {
    return this.authHttp.post(`/api/AdminUser/ChangeProfile`, poUserProfile, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Change profile request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }
  getCreditCards() {
    return this.authHttp.get(`/api/CreditCard/GetCreditCards`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Get Credit Cardds request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  getCountries() {
    return this.authHttp.get(`/api/CreditCard/GetCountries`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Get Countries request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  getCardTypes() {
    return this.authHttp.get(`/api/CreditCard/GetCreditCardTypes`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Get credit card types request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  isCreditCardAccountExists(accountNumber: string) {
    return this.authHttp.get(`/api/CreditCard/IsCreditCardAccountExists?psAccountNumber=` + accountNumber,
      { headers: this.myHeader }).map(res => {
        if (res.status < 200 || res.status > 300) {
          throw new Error('Get isCreditCardAccountExists request has failed ' + res.status);
        } else {
          return res.json();
        }
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.auth.logOut();
        }

        return Observable.throw(err);
      });
  }

  saveCreditCard(creditCardModel: CreditCard) {
    return this.authHttp.post(`/api/CreditCard/InsertCreditCard`, creditCardModel, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Insert Credit Card request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  deleteCreditCard(creditCardID: string) {
    return this.authHttp.post(`/api/CreditCard/DeleteCreditCard`, new Object(creditCardID), { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Delete Credit Card request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  getCreditCardDetails(creditCardID: string) {
    return this.authHttp.get(`/api/CreditCard/GetCreditCardInfoById?psCCID=` + creditCardID,
      { headers: this.myHeader }).map(res => {
        if (res.status < 200 || res.status > 300) {
          throw new Error('Get Credit Card Details request has failed ' + res.status);
        } else {
          return res.json();
        }
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.auth.logOut();
        }

        return Observable.throw(err);
      });
  }

  updateCreditCardDetails(creditCardModel: CreditCard) {
    return this.authHttp.post(`/api/CreditCard/UpdateCreditCard`, creditCardModel, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Insert Credit Card request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  deleteUser(childUserLogonID: string) {
    return this.authHttp.post(`/api/AdminUser/RemoveUser`, new Object(childUserLogonID), { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Delete User has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  saveUser(userModel: User) {
    return this.authHttp.post(`/api/AdminUser/SaveNewUser`, userModel, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Save User has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  getUserInfoByUserName(logonID: string) {
    return this.authHttp.get(`/api/AdminUser/GetUserInfoByUserName?psUserName=` + logonID,
      { headers: this.myHeader }).map(res => {
        if (res.status < 200 || res.status > 300) {
          throw new Error('getUserInfoByUserName request has failed ' + res.status);
        } else {
          return res.json();
        }
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.auth.logOut();
        }

        return Observable.throw(err);
      });
  }

  getBankAccounts() {
    return this.authHttp.get(`/api/Bank/GetBankAccounts`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Get Credit Cardds request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  deleteBankAccount(BAID: string) {
    return this.authHttp.post(`/api/Bank/DeleteBankAccount`, new Object(BAID), { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Delete Credit Card request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }
  getBankAccountTypes() {
    return this.authHttp.get(`/api/Bank/GetBankAccountTypes`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Get Credit Cardds request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  saveBankAccount(bankAccModel: BankAcc) {
    return this.authHttp.post(`/api/Bank/InsertBankAccount`, bankAccModel, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Insert Credit Card request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }
  saveVedorBankAccount(bankAccModel: BankAcc) {
    return this.authHttp.post(`/api/Bank/VendorInsertBankAccount`, bankAccModel, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Insert Bank account request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  isBankAccountExists(accountNumber: string) {
    return this.authHttp.get(`/api/Bank/IsBankAccountExists?psAccountNumber=` + accountNumber,
      { headers: this.myHeader }).map(res => {
        if (res.status < 200 || res.status > 300) {
          throw new Error('Get isBankAccountExists request has failed ' + res.status);
        } else {
          return res.json();
        }
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.auth.logOut();
        }

        return Observable.throw(err);
      });
  }

  getBankAccountDetails(BAID: string) {
    return this.authHttp.get(`/api/Bank/GetBankAccountInfoById?psBAID=` + BAID,
      { headers: this.myHeader }).map(res => {
        if (res.status < 200 || res.status > 300) {
          throw new Error('Get Bank account Details request has failed ' + res.status);
        } else {
          return res.json();
        }
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.auth.logOut();
        }

        return Observable.throw(err);
      });
  }
  updateBankAccountDetails(bankAccountModel: BankAcc) {
    return this.authHttp.post(`/api/Bank/UpdateBankAccount`, bankAccountModel, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Update bank account request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  getUserInfoByID(childLID: string) {
    return this.authHttp.get(`/api/AdminUser/GetUserInfoByID?psChildLID=` + childLID,
      { headers: this.myHeader }).map(res => {
        if (res.status < 200 || res.status > 300) {
          throw new Error('getUserInfoByUserName request has failed ' + res.status);
        } else {
          return res.json();
        }
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.auth.logOut();
        }

        return Observable.throw(err);
      });
  }

  updateUser(userModel: User) {
    return this.authHttp.post(`/api/AdminUser/UpdateUser`,  userModel, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Update User has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  async getCurrentUserTypeAsync() {
    const response = await this.authHttp.get(`/api/AdminUser/GetCurrentUserType`, { headers: this.myHeader }).toPromise();
    return response.json();
  }

  getLiveChatDetails() {
    return this.authHttp.get(`/api/AdminUser/GetLiveChatDetails`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('getLiveChatDetails request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  getVAMUsers(searchText: string) {
    return this.authHttp.get(`/api/AdminUser/GetVAMUsers?psSearchText=` + searchText, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Get VAM Users request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  updateVAMUserStatus(userInfo: User) {
    return this.authHttp.post(`/api/AdminUser/UpdateVAMUserStatus`, userInfo,
      { headers: this.myHeader }).map(res => {
        if (res.status < 200 || res.status > 300) {
          throw new Error('Update VAM User Status has failed ' + res.status);
        } else {
          return res.json();
        }
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.auth.logOut();
        }

        return Observable.throw(err);
      });
  }

  saveVAMUser(userModel: User) {
    return this.authHttp.post(`/api/AdminUser/SaveNewVAMUser`, userModel, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Save VAM User has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  deleteVAMUser(childUserLogonID: string) {
    return this.authHttp.post(`/api/AdminUser/RemoveVAMUser`, new Object(childUserLogonID), { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Delete VAM User has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  isVendorBankAccountExists(bankName: string, accountNumber: string, gpVID: string) {
    // tslint:disable-next-line:max-line-length
    return this.authHttp.get(`/api/Bank/IsVendorBankAccountExist?psBankName=` + bankName + `&psAccountNumber=` + accountNumber + `&psGPVID=` + gpVID,
      { headers: this.myHeader }).map(res => {
        if (res.status < 200 || res.status > 300) {
          throw new Error('Get isVendorBankAccountExists request has failed ' + res.status);
        } else {
          return res.json();
        }
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.auth.logOut();
        }

        return Observable.throw(err);
      });
  }

  async getConfig(key: string): Promise<any> {
    return this.authHttp.get(`/api/Contract/GetConfig?psKey=` + key,
      { headers: this.myHeader }).toPromise().then(function (res) {
        console.log(res);
        return res.text();
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.auth.logOut();
        }

        return Observable.throw(err);
      });
  }

  async getEncryptedUserInfo(): Promise<any> {
    return this.authHttp.get(`/api/AdminUser/GetEncryptedUserInfo`,
      { headers: this.myHeader }).toPromise().then(function (res) {
        console.log(res);
        return res.json();
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.auth.logOut();
        }

        return Observable.throw(err);
      });
  }
}




// WEBPACK FOOTER //
// ./src/app/services/Admin.service.ts